import React from 'react';
import T from 'prop-types';
import { useSelector } from 'react-redux';
import { pick } from 'lodash-es';

import CsvExportButton from '../../../components/Buttons/CsvExportButton';
import api from '../api';
import { aiDashboardAssets } from '../configs/constants';

const PERMITTED_FILTERS = ['granularity', 'change_type', 'app_uid', 'month_date'];

const EXPORTABLE_ASSETS = [
  aiDashboardAssets.marketOverview,
  aiDashboardAssets.timeSpentPenetration,
  aiDashboardAssets.usageTrends,
  aiDashboardAssets.usageTransitions,
  aiDashboardAssets.segmentConcentration,
  aiDashboardAssets.sectorsStats,
  aiDashboardAssets.aiAppTrends,
  aiDashboardAssets.segmentTransitions,
  aiDashboardAssets.aiAppImpact,
];

const TabExportButton = ({ isPublic = false }) => {
  const aiDashboard = useSelector((state) => state.aiDashboard);

  const assets = EXPORTABLE_ASSETS.map((assetName) => {
    const asset = aiDashboard[assetName];
    return {
      asset_name: assetName,
      filters: pick(asset.filters || {}, PERMITTED_FILTERS),
    };
  });

  const pending = EXPORTABLE_ASSETS.some((assetName) => aiDashboard[assetName].settings.pending);

  const handleTooltipShow = (isVisible) => {
    if (isVisible && isPublic && window.heap) {
      window.heap.track('Gen AI App Insights Marketing Export', { event: 'hover' });
    }
  };

  return (
    <CsvExportButton
      url={api.buildExportUrl('export')}
      disabled={isPublic || pending}
      tooltipText={isPublic ? 'Available with full access' : 'Download data to CSV'}
      method="post"
      colorVariant="light"
      body={{ assets }}
      featureNameText="Gen AI App Insights Export"
      onVisibleChange={handleTooltipShow}
    />
  );
};

TabExportButton.propTypes = {
  isPublic: T.bool,
};

export default TabExportButton;
